/*
  Buy box de las fichas nativas (snippets/buybox.liquid) y su barra sticky
  (snippets/sticky-add-to-cart-bar.liquid). Un solo archivo para todos los buy
  box de la pagina: Sky renderiza dos (un color cada uno) y la home o las
  landings pueden tener otro.

  Tres cosas:
  1. Selector de kit: al elegir una tarjeta actualiza la cantidad del form y el
     precio del kit. Los importes ya vienen calculados por Liquid en data-* del
     radio: aca no se calcula ningun precio.
  2. Agregar al carrito: un solo handler, en captura, antes que el de
     product-form.js (que depende de CartJS/jQuery). Muestra el error de Shopify
     si falla (sin stock, limite) y no deja agregar dos veces.
  3. Barra sticky: es un espejo del buy box visible. Muestra el kit elegido y su
     precio, y su boton envia el form principal. En los buy box de suscripcion
     (filtros, Energy Saver Plan, door sensor) no hay form: la sticky aprieta el
     boton visible, que agrega con su plan de suscripcion. Sin buy box en la
     pagina sigue con su propio form de 1 unidad.

  Si este archivo todavia no cargo cuando el cliente toca el boton, el form se
  envia de forma nativa a /cart/add y Shopify redirige al carrito: el input
  name="id" ya no sale deshabilitado.
*/
(function () {
  if (window.SensiboBuybox) return;

  var routes = window.routes || {};
  var CART_URL = routes.cart_url || '/cart';
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var T = window.sensiboBuyboxStrings || {};
  var MAIN_FORM = 'form[data-type="add-to-cart-form"]';

  function isShown(el) {
    return !!(el && el.offsetParent !== null);
  }

  /* ---------- 1. Selector de kit ---------- */

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function applyKit(radio) {
    var box = radio.closest('.product-template');
    if (!box) return;
    var d = radio.dataset;

    var form = document.getElementById(radio.getAttribute('form'));
    var qty = form && form.querySelector('[name="quantity"]');
    if (qty) qty.value = radio.value;

    var price = box.querySelector('.chosen-variant-price');
    if (price) {
      setText(price.querySelector('.global-variant-price'), d.kitTotal);
      var compare = price.querySelector('.global-variant-compare-price');
      if (compare) {
        setText(compare, d.kitCompare || '');
        compare.hidden = !d.kitCompare;
      }
    }

    /* Banner de Buy with Prime: solo con 1 unidad (Amazon vende de a una). */
    box.querySelectorAll('[data-bwp-banner], [data-bwp-banner-mobile]').forEach(function (banner) {
      banner.classList.toggle('hidden', radio.value !== '1');
    });

    syncSticky();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="selector-quantity"][data-kit-total]')) applyKit(t);
  });

  /* ---------- 2. Agregar al carrito ---------- */

  function buttonOf(form) {
    return form.querySelector('[type="submit"][name="add"]');
  }

  function setBusy(form, busy) {
    var btn = buttonOf(form);
    if (!btn) return;
    btn.classList.toggle('loading', busy);
    if (busy) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
    }
    document.dispatchEvent(new CustomEvent('sensibo:buybox-busy', { detail: { form: form, busy: busy } }));
  }

  function showError(form, message) {
    var wrap = form.closest('product-form');
    wrap = wrap && wrap.querySelector('.product-form__error-message-wrapper');
    if (!wrap) return;
    var text = wrap.querySelector('.product-form__error-message');
    if (text) text.textContent = message || '';
    wrap.hidden = !message;
  }

  function addToCart(form) {
    var btn = buttonOf(form);
    if (!btn || btn.disabled || form.dataset.busy) return;
    form.dataset.busy = '1';
    setBusy(form, true);
    showError(form, '');

    fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || T.error || 'Something went wrong. Please try again.');
        /* Queda ocupado hasta que cargue el carrito: un segundo toque no agrega otro kit. */
        window.location.href = CART_URL;
      })
      .catch(function (err) {
        delete form.dataset.busy;
        setBusy(form, false);
        showError(form, err && err.message);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;

    /* Barra sticky: si hay un buy box visible, compra lo que esta elegido ahi. */
    if (form.matches('.sensibo-sticky-bar__form')) {
      var main = activeForm();
      var subButton = main ? null : activeSubButton();
      if (!main && !subButton) return; /* landings sin buy box: envio nativo de 1 unidad */
      e.preventDefault();
      e.stopImmediatePropagation();
      if (main) addToCart(main);
      else if (!subButton.disabled) subButton.click();
      return;
    }

    if (form.matches(MAIN_FORM) && form.closest('.product-template')) {
      e.preventDefault();
      e.stopImmediatePropagation(); /* que no corra tambien product-form.js */
      addToCart(form);
    }
  }, true);

  /* Volver con "atras" desde el carrito: el boton tiene que volver a andar. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll(MAIN_FORM).forEach(function (form) {
      delete form.dataset.busy;
      setBusy(form, false);
    });
    /* Sin bfcache el navegador puede restaurar el radio sin la cantidad. */
    document.querySelectorAll('input[name="selector-quantity"][data-kit-total]:checked').forEach(applyKit);
  });

  /* ---------- 3. Barra sticky como espejo ---------- */

  /* Primero el buy box principal de la ficha; despues cualquier otro de la pagina. */
  function firstShown(selector, pick) {
    var scopes = [document.querySelector('.air-bbx__buy'), document];
    for (var k = 0; k < scopes.length; k++) {
      if (!scopes[k]) continue;
      var list = scopes[k].querySelectorAll(selector);
      for (var i = 0; i < list.length; i++) if (isShown(pick(list[i]))) return list[i];
    }
    return null;
  }

  function activeForm() {
    return firstShown('.product-template ' + MAIN_FORM, buttonOf);
  }

  /* Boton visible de los buy box de suscripcion (no tienen form). */
  function activeSubButton() {
    return firstShown('[data-sub-add], [data-door-add]', function (b) { return b; });
  }

  function syncStickyFromButton(bar, button) {
    var box = button.closest('.product-template, .airbend-info') || document;
    var title = document.querySelector('.air-bbx .product-title');
    bar.querySelectorAll('.sensibo-sticky-bar__name').forEach(function (el) {
      if (title) el.textContent = title.textContent.trim();
    });
    bar.querySelectorAll('.sensibo-sticky-bar__price-final').forEach(function (el) {
      if (button.dataset.stickyPrice) setText(el, button.dataset.stickyPrice);
    });
    bar.querySelectorAll('.sensibo-sticky-bar__price-original, .sensibo-sticky-bar__badge, .sensibo-sticky-bar__kit').forEach(function (el) {
      el.hidden = true;
    });
    bar.querySelectorAll('.sensibo-sticky-bar__cta').forEach(function (b) {
      b.disabled = button.disabled && button.getAttribute('aria-busy') !== 'true';
      if (b.disabled) b.textContent = T.soldOut || 'Sold out';
    });
  }

  function syncSticky() {
    var bar = document.getElementById('sensibo-sticky-bar');
    if (!bar) return;
    var form = activeForm();
    if (!form) {
      var sub = activeSubButton();
      if (sub) syncStickyFromButton(bar, sub);
      return;
    }
    var box = form.closest('.product-template');
    var radio = box.querySelector('input[name="selector-quantity"][data-kit-total]:checked');
    var title = box.querySelector('.product-title');
    var mainBtn = buttonOf(form);

    bar.querySelectorAll('.sensibo-sticky-bar__name').forEach(function (el) {
      if (title) el.textContent = title.textContent.trim();
    });
    if (box.dataset.stickyThumb) {
      bar.querySelectorAll('.sensibo-sticky-bar__thumb img').forEach(function (img) {
        img.src = box.dataset.stickyThumb;
      });
    }
    if (radio) {
      var d = radio.dataset;
      bar.querySelectorAll('.sensibo-sticky-bar__price-final').forEach(function (el) { setText(el, d.kitTotal); });
      bar.querySelectorAll('.sensibo-sticky-bar__price-original').forEach(function (el) {
        setText(el, d.kitCompare || '');
        el.hidden = !d.kitCompare;
      });
      bar.querySelectorAll('.sensibo-sticky-bar__badge').forEach(function (el) {
        var off = parseInt(d.kitOff, 10);
        setText(el, off > 0 ? '-' + off + '%' : '');
        el.hidden = !(off > 0);
      });
      bar.querySelectorAll('.sensibo-sticky-bar__kit').forEach(function (el) {
        setText(el, d.kitName || '');
        el.hidden = !d.kitName;
      });
    }
    var soldOut = mainBtn && mainBtn.disabled;
    bar.querySelectorAll('.sensibo-sticky-bar__cta').forEach(function (b) {
      b.disabled = !!soldOut;
      if (soldOut) b.textContent = T.soldOut || 'Sold out';
    });
  }

  document.addEventListener('sensibo:buybox-busy', function (e) {
    var bar = document.getElementById('sensibo-sticky-bar');
    if (!bar) return;
    bar.querySelectorAll('.sensibo-sticky-bar__cta').forEach(function (b) {
      if (b.disabled && !e.detail.busy) return;
      b.classList.toggle('loading', e.detail.busy);
      if (e.detail.busy) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
    });
  });

  /* Sky cambia de color sin evento change: se resincroniza al mostrar la barra. */
  document.addEventListener('sensibo:sticky-shown', syncSticky);
  document.addEventListener('sensibo:color-changed', syncSticky);

  function init() {
    document.querySelectorAll('input[name="selector-quantity"][data-kit-total]:checked').forEach(function (r) {
      var form = document.getElementById(r.getAttribute('form'));
      var qty = form && form.querySelector('[name="quantity"]');
      if (qty) qty.value = r.value;
    });
    syncSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.SensiboBuybox = { syncSticky: syncSticky, addToCart: addToCart };
})();
